import React from "react";

export default function SectionHeader({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`${align === "center" ? "text-center max-w-3xl mx-auto" : "max-w-3xl"} mb-10 md:mb-14`}>
      {eyebrow && <div className="ae-eyebrow mb-3">{eyebrow}</div>}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#101827] leading-[1.1] tracking-tight">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-[#475569] text-base sm:text-lg leading-relaxed">{subtitle}</p>}
    </div>
  );
}
